/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelInvitation200Response
 */
export interface CancelInvitation200Response {
    /**
     * 
     * @type {boolean}
     * @memberof CancelInvitation200Response
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CancelInvitation200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the CancelInvitation200Response interface.
 */
export function instanceOfCancelInvitation200Response(value: object): value is CancelInvitation200Response {
    return true;
}

export function CancelInvitation200ResponseFromJSON(json: any): CancelInvitation200Response {
    return CancelInvitation200ResponseFromJSONTyped(json, false);
}

export function CancelInvitation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelInvitation200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function CancelInvitation200ResponseToJSON(json: any): CancelInvitation200Response {
    return CancelInvitation200ResponseToJSONTyped(json, false);
}

export function CancelInvitation200ResponseToJSONTyped(value?: CancelInvitation200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

